webpackJsonp([204533827269667],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(43);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fullLogoOnWhite = __webpack_require__(55);
	
	var _fullLogoOnWhite2 = _interopRequireDefault(_fullLogoOnWhite);
	
	var _reactStripeCheckout = __webpack_require__(78);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "container", "data-jsx": 64760230
	    },
	    _react2.default.createElement(
	      "header",
	      {
	        "data-jsx": 64760230
	      },
	      _react2.default.createElement(
	        "h1",
	        {
	          "data-jsx": 64760230
	        },
	        "Quiver speed comparison"
	      )
	    ),
	    _react2.default.createElement("iframe", {
	      src: "https://speed.graphql-quiver.com/",
	      frameborder: "0",
	      id: "benchmarks-iframe",
	      "data-form-source": "https://speed.graphql-quiver.com/",
	      className: "iframe-form ",
	      "data-pass-through-params": "code next platform trial plan period referrer",
	      "data-jsx": 64760230
	    }),
	    _react2.default.createElement(_style2.default, {
	      styleId: 64760230,
	      css: "#benchmarks-iframe[data-jsx=\"64760230\"]{border:none;width:100%;height:900px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9iZW5jaG1hcmtzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9Ca0IsQUFHdUIsWUFDRCxXQUNFLGFBQ2YiLCJmaWxlIjoic3JjL3BhZ2VzL2JlbmNobWFya3MuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IExpbmsgZnJvbSBcImdhdHNieS1saW5rXCI7XG5pbXBvcnQgRnVsbExvZ29PbldoaXRlIGZyb20gXCIuL2Z1bGwtbG9nby1vbi13aGl0ZS5zdmdcIjtcbmltcG9ydCBTdHJpcGVDaGVja291dCBmcm9tIFwicmVhY3Qtc3RyaXBlLWNoZWNrb3V0XCI7XG5pbXBvcnQgeyB3aXRoUHJlZml4IH0gZnJvbSBcImdhdHNieS1saW5rXCI7XG5cbmV4cG9ydCBkZWZhdWx0ICgpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNsYXNzTmFtZT1cImNvbnRhaW5lclwiPlxuICAgICAgPGhlYWRlcj5cbiAgICAgICAgPGgxPlF1aXZlciBzcGVlZCBjb21wYXJpc29uPC9oMT5cbiAgICAgIDwvaGVhZGVyPlxuICAgICAgPGlmcmFtZVxuICAgICAgICBzcmM9XCJodHRwczovL3NwZWVkLmdyYXBocWwtcXVpdmVyLmNvbS9cIlxuICAgICAgICBmcmFtZWJvcmRlcj1cIjBcIlxuICAgICAgICBpZD1cImJlbmNobWFya3MtaWZyYW1lXCJcbiAgICAgICAgZGF0YS1mb3JtLXNvdXJjZT1cImh0dHBzOi8vc3BlZWQuZ3JhcGhxbC1xdWl2ZXIuY29tL1wiXG4gICAgICAgIGNsYXNzTmFtZT1cImlmcmFtZS1mb3JtIFwiXG4gICAgICAgIGRhdGEtcGFzcy10aHJvdWdoLXBhcmFtcz1cImNvZGUgbmV4dCBwbGF0Zm9ybSB0cmlhbCBwbGFuIHBlcmlvZCByZWZlcnJlclwiXG4gICAgICAvPlxuICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAjYmVuY2htYXJrcy1pZnJhbWUge1xuICAgICAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICBoZWlnaHQ6IDkwMHB4O1xuICAgICAgICB9XG4gICAgICBgfTwvc3R5bGU+XG4gICAgPC9kaXY+XG4gICk7XG59O1xuIl19 */\n/*@ sourceURL=src/pages/benchmarks.js */"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-benchmarks-js-2d62fcd03650ce43be73.js